import asset from './asset'
import search from './search'
import list from './list'
import catalog from './catalog'
import details from './details'
import create from './create'
import update from './update'
import remove from './remove'
import password from './password'
import managedLocations from './managedLocations'
import managedDepartments from './managedDepartments'
import addFloorToManagedLocations from './addFloorToManagedLocations'
import deleteFloorFromManagedLocations from './deleteFloorFromManagedLocations'
import deleteDepartmentFromManagedDepartments from './deleteDepartmentFromManagedDepartments'
import addDepartmentToManagedDepartements from './addDepartmentToManagedDepartements'
import createExport from './createExport'
import checkExportStatus from './checkExportStatus'
import batchUpdateRole from './batchUpdateRole'
import preferredLocations from './preferredLocations'
import eimport from './import'
import exemptFromCheckin from './exemptFromCheckin'
import toggleRemote from './toggleRemote'
import updateDeptEmpForBookingManager from './updateBookingManagerSettings'
import selfMove from './selfMove'
import toggleExcludeFromUnseated from './changeExcludedToEmployees'

export default {
  asset,
  search,
  list,
  catalog,
  details,
  update,
  create,
  password,
  remove,
  managedLocations,
  managedDepartments,
  addFloorToManagedLocations,
  deleteFloorFromManagedLocations,
  addDepartmentToManagedDepartements,
  deleteDepartmentFromManagedDepartments,
  createExport,
  checkExportStatus,
  batchUpdateRole,
  preferredLocations,
  import: eimport,
  exemptFromCheckin,
  toggleRemote,
  updateDeptEmpForBookingManager,
  selfMove,
  toggleExcludeFromUnseated,
}
